module.exports = __webpack_public_path__ + "img/lomexin-2.d4ca23b7.png";